import { tablesConstants } from "../_constants";
import { tablesServices } from "../_services";
import { alertActions } from ".";

export const tablesActions = {
  getAllTables,
  getTableById,
  getTopCardTables,
  uploadDictionaryByTableId,
  addTable,
  getTableByConnectionId,
  getDataDictionaryByTableId,
  connfiqureTableById,
  editTableById,
  editDataQualityById,
  getDataQualityByTableId,
  deleteDataQualityById,
  addConfiguredTableById,
  searchTables,
  getTablesFilters,
  applyTablesFilters,
  getDataDictionary,
  searchDataDictionary,
  activateTable,
  searchDataQuality,
  applyDataQualityFilters,
  fetchActiveTableByConnectionId,
};

function getAllTables(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getAllTables(offset, limit).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_ALL_TABLES_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_ALL_TABLES_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_ALL_TABLES_FAILURE, error };
  }
}

function getTopCardTables() {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getTopCardTables().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_TOP_CARDS_TABLES_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_TOP_CARDS_TABLES_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.GET_TOP_CARDS_TABLES_FAILURE,
      error,
    };
  }
}

function getTableById(tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getTableById(tableId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_TABLE_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_TABLE_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_TABLE_BY_ID_FAILURE, error };
  }
}

function uploadDictionaryByTableId(formData, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.uploadDictionaryByTableId(formData, tableId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_FAILURE,
      error,
    };
  }
}

function addTable(formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.addTable(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.ADD_TABLE_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.ADD_TABLE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.ADD_TABLE_FAILURE, error };
  }
}

function getTableByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getTableByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_TABLES_BY_CONNECTION_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_TABLES_BY_CONNECTION_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_TABLES_BY_CONNECTION_ID_FAILURE, error };
  }
}

function getDataDictionaryByTableId(tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getDataDictionaryByTableId(tableId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_FAILURE,
      error,
    };
  }
}

function connfiqureTableById(tableId, formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.configureTableById(tableId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.CONFIGURE_TABLE_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.CONFIGURE_TABLE_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.CONFIGURE_TABLE_BY_ID_FAILURE, error };
  }
}

function editTableById(tableId, formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.editTableById(tableId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.EDIT_TABLE_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.EDIT_TABLE_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.EDIT_TABLE_BY_ID_FAILURE, error };
  }
}

function editDataQualityById(dataQualityConfigId, formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.editDataQualityById(dataQualityConfigId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.EDIT_DATA_QUALITY_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.EDIT_DATA_QUALITY_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.EDIT_DATA_QUALITY_BY_ID_FAILURE, error };
  }
}

function getDataQualityByTableId(offset, limit, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getDataQualityByTableId(offset, limit, tableId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_FAILURE,
      error,
    };
  }
}

function deleteDataQualityById(dataQualityConfigId, formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.deleteDataQualityById(dataQualityConfigId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.DELETE_DATA_QUALITY_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.DELETE_DATA_QUALITY_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.DELETE_DATA_QUALITY_BY_ID_FAILURE, error };
  }
}

function addConfiguredTableById(tableId, formData) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.addConfiguredTableById(tableId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.ADD_CONFIGURED_TABLE_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.ADD_CONFIGURED_TABLE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.ADD_CONFIGURED_TABLE_FAILURE, error };
  }
}

function searchTables(searchText, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.searchTables(searchText, offset, limit).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_ALL_TABLES_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_ALL_TABLES_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_ALL_TABLES_FAILURE, error };
  }
}

function getTablesFilters() {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getTablesFilters().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_TABLES_FILTERS_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_TABLES_FILTERS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_TABLES_FILTERS_FAILURE, error };
  }
}

function applyTablesFilters(
   connection,
      user,
      workspace,
      startDate,
      endDate,
      search,
      offset,
      limit,
      endpoint, 
      source,
) {
  return (dispatch) => {
    dispatch(request());
    tablesServices
      .applyTablesFilters(
         connection,
      user,
      workspace,
      startDate,
      endDate,
      search,
      offset,
      limit,
      endpoint, 
      source,
      )
      .then(
        (data) => {
          dispatch(success(data));
        },
        (error) => {
          dispatch(failure(error.toString()));
        }
      );
  };

  function request() {
    return { type: tablesConstants.GET_ALL_TABLES_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_ALL_TABLES_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_ALL_TABLES_FAILURE, error };
  }
}

function getDataDictionary(offset = 0, limit = 10, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.getDataDictionary(offset, limit, tableId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_DICTIONARY_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_DICTIONARY_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_DATA_DICTIONARY_FAILURE, error };
  }
}

function searchDataDictionary(searchText, offset = 0, limit = 10, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices
      .searchDataDictionary(searchText, offset, limit, tableId)
      .then(
        (data) => {
          dispatch(success(data));
        },
        (error) => {
          dispatch(failure(error.toString()));
        }
      );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_DICTIONARY_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_DICTIONARY_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.GET_DATA_DICTIONARY_FAILURE, error };
  }
}

function activateTable(isActive, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.activateTable(isActive, tableId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.ACTIVATE_TABLE_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.ACTIVATE_TABLE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.ACTIVATE_TABLE_FAILURE, error };
  }
}

function searchDataQuality(searchText, offset, limit, tableId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.searchDataQuality(searchText, offset, limit, tableId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_FAILURE,
      error,
    };
  }
}

function applyDataQualityFilters(
 functionType,
      functionName,
      search,
      offset,
      limit,
      tableId
) {
  return (dispatch) => {
    dispatch(request());
    tablesServices
      .applyDataQualityFilters(
     functionType,
      functionName,
      search,
      offset,
      limit,
      tableId
      )
      .then(
        (data) => {
          dispatch(success(data));
        },
        (error) => {
          dispatch(failure(error.toString()));
        }
      );
  };

  function request() {
    return { type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_FAILURE,
      error,
    };
  }
}

function fetchActiveTableByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    tablesServices.fetchActiveTableByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_REQUEST };
  }
  function success(data) {
    return {
      type: tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_FAILURE, error };
  }
}
